import { Tag } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { Organization } from "../../models/Organization/Organization";
import { TFullOrganizationAttr } from "../../models/Organization/Types";
import { RootState } from "../../redux/reducers";
import AppSimplePage from "../AppSimplePage/AppSimplePage";
import Styles from "./index.scss";
import subFailedImg from "../../assets/img/subscription_failed_placeholder.png";

const SubscriptionIssuePage = () => {
    const activeOrg = useSelector<RootState, Organization>((state) => state.orgs.activeOrg!);
    return (
        <AppSimplePage
            hideSidebar
            content={
                <div className={Styles.SubscriptionIssuePage}>
                    <div className={Styles.Image}>
                        <img src={subFailedImg} />
                    </div>
                    <div className={Styles.Header}>Invalid/Expired Subscription</div>
                    <div className={Styles.Description}>
                        It looks like your subscription to Ausplan is invalid or has expired. Please contact support for further assistance
                    </div>
                    <div className={Styles.SubStatusContainer}>
                        <div className={Styles.Name}>Subscription Status</div>
                        <Tag color="red">{(activeOrg.data.attrs as TFullOrganizationAttr).subscription?.status}</Tag>
                    </div>
                </div>
            }
        />
    );
};

export default SubscriptionIssuePage;
